import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const { language } = useLanguage();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(res => setTestimonials(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white font-body" data-testid="testimonials-page">
      <Navbar />

      <PageHero
        kicker={language === 'en' ? 'In their words' : 'उनकी जुबानी'}
        title={language === 'en' ? 'Patient Stories' : 'मरीजों की कहानियां'}
        subtitle={language === 'en' ? 'Hear what our patients say about their experience' : 'सुनें कि हमारे मरीज अपने अनुभव के बारे में क्या कहते हैं'}
        testId="testimonials-hero"
      />

      <div className="py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6">
          {loading ? (
            <div className="text-center text-neutral-400">Loading...</div>
          ) : testimonials.length > 0 ? (
            <div className="space-y-20" data-testid="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={testimonial.id} className="text-center max-w-3xl mx-auto" data-testid={`testimonial-card-${index}`}>
                  <div className="flex items-center justify-center mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="text-brand-teal text-lg mx-1">&#9733;</span>
                    ))}
                  </div>
                  <p className="font-heading font-light text-xl sm:text-2xl leading-relaxed text-brand-navy mb-8 italic">
                    &ldquo;{language === 'en' ? testimonial.content_en : testimonial.content_hi}&rdquo;
                  </p>
                  <div className="w-12 h-px bg-brand-teal mx-auto mb-4"></div>
                  <p className="text-xs uppercase tracking-ultra-wide text-neutral-500 font-body">
                    {language === 'en' ? testimonial.patient_name_en : testimonial.patient_name_hi}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-neutral-400 font-body">
              {language === 'en' ? 'No testimonials available' : 'कोई प्रशंसापत्र उपलब्ध नहीं'}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Testimonials;
